<template>
  <div>
    <div>
      <div class="mt-2">
        <input
          :id="`imageInput_${idx}`"
          ref="imageInput"
          type="file"
          :accept="mimeTypes"
          style="display: none"
          @change="loadFileFromInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'

export default {
  props: {
    idx: [String, Number],
    files: Array,
    mimeTypes: {
      type: String,
      required: false,
      default: '*'
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      getCurrentEvents: storeUtils.getterName(storeLabel.FILE_EVENTS, storeLabel.COMMON_MODULE)
    })
  },
  created () {
  },
  methods: {
    onPickFile () {
      this.$refs.imageInput.$el.click()
    },
    onFileLoaded (file) {
      this.eventsBus.$emit(this.getCurrentEvents.loadedEvent, {
        file
      })
    },
    /**
       * Получение файла
       * @param {Object} e
       */
    async loadFileFromInput (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.onFileLoaded(files[0])
          this.$refs.imageInput.value = ''
        })
      } else {
        this.currentDetailIndex = null
      }
    }
  }
}
</script>
